
  import { Component, Prop, Vue } from 'vue-property-decorator'

  @Component({ name: 'BaseIcon' })
  export default class extends Vue {
    @Prop()
    title: string
  }
